import { getApiClient, initializeApiClient } from "../../apiService";

export const UpdateAdvertising = async (AdvertisingAndMediaPlan) => {
  await initializeApiClient();
  const apiClient = await getApiClient();
  const response = await apiClient.post(
    `/api/MP_MarketingResourcesAndPublications/UpdateMP_MarketingResourcesAndPublicationsData`,
    {
      mP_MarketingResourcesAndPublicationsId:
        AdvertisingAndMediaPlan.mP_MarketingResourcesAndPublicationsId,
      mP_MR_ItemId: AdvertisingAndMediaPlan.mP_MR_ItemId,
      itemNameAnother: AdvertisingAndMediaPlan.itemNameAnother,
      descriptionContentObjective:
        AdvertisingAndMediaPlan.descriptionContentObjective,
      quantity: AdvertisingAndMediaPlan.quantity,
      mediaAndAdvertisingPlanExplanation:
        AdvertisingAndMediaPlan.mediaAndAdvertisingPlanExplanation,
      aP_AdvertisingAndMediaPlanId:
        AdvertisingAndMediaPlan.aP_AdvertisingAndMediaPlanId,
    }
  );

  return response;
};

export default UpdateAdvertising;
